import { useRef, useEffect } from 'react';

type AudioMap = {
  [key: string]: HTMLAudioElement;
};

export function useAudioPlayer(
  soundMap: { [key: string]: string | undefined },
  volume: number = 0.3,
) {
  const audioRef = useRef<AudioMap>({});

  useEffect(() => {
    const loaded: AudioMap = {};
    Object.entries(soundMap).forEach(([key, url]) => {
      if (url) {
        const audio = new Audio(url);
        audio.volume = volume;
        audio.preload = 'auto';
        loaded[key] = audio;
      }
    });
    audioRef.current = loaded;

    return () => {
      Object.values(loaded).forEach((audio) => {
        audio.pause();
        audio.src = '';
      });
    };
  }, [JSON.stringify(soundMap)]); // URL이 바뀌면 다시 로드

  const play = (key: keyof typeof soundMap) => {
    const audio = audioRef.current[key];
    if (audio) {
      // console.log(`🎵 Playing sound: ${key}`);
      audio.currentTime = 0;
      audio.play().catch((err) => {
        // console.warn(`🔇 Audio play error for ${key}:`, err);
      });
    } else {
      // console.log(`🚫 No audio found for ${key}`);
    }
  };

  return { play };
}
